import React from "react";
import css from "./CardGrid.module.css";
import henSuburb from "../../assets/images/hensSuburb.jpg";
import theFullPoop from "../../assets/images/theFullPoop.jpg";
import lobsterEggs from "../../assets/images/lobsterEggs.jpg";
import twelvePlates from "../../assets/images/twelvePlates.jpg";
import chickenWhisper from "../../assets/images/theChickenWhisper.jpg";
import maynardG from "../../assets/images/maynardG.jpg";

const data = [
  { id: 1, title: "HENS IN THE SUBURBS", series: "The Chicken Man", img: henSuburb, price: "$9.99", btnUrl: "https://www.amazon.com/dp/B0G4JLHJ9B" },
  { id: 2, title: "The Full Poop on Building A Coop (The Chicken Man)", series: "The Chicken Man", img: theFullPoop, price: "$9.99", btnUrl: "https://www.amazon.com/dp/B0G4J6QR7G" },
  { id: 3, title: "Lobster Eggs Benedict On Little Whelk Bay: Norma Jeane's Day Out", series: "The Chicken Man", img: lobsterEggs, price: "$8.99", btnUrl: "https://www.amazon.com/dp/B0G4HBK7PD"  },
  { id: 4, title: "The Twelve Plates of Chicken: Recipes, Stories, and Coloring Plates", series: "The Chicken Man", img: twelvePlates, price: "$16.99", btnUrl: "https://www.amazon.com/dp/B0G4G4QYFV" },
  { id: 5, title: "The Chicken Whisperer", series: "The Chicken Man", img: chickenWhisper, price: "$9.99", btnUrl: "https://www.amazon.com/dp/B0G485CYTF" },
  { id: 6, title: "Maynard G And His Pontoon Chicken Coop: Season 01 - Episode 02", series: "The Chicken Man", img: maynardG, price: "$9.99", btnUrl: "https://www.amazon.com/dp/B0G4K9WMVH" },
];

const CardGrid = () => {
  return (
    <div className={css.gridWrapper}>
      {data.map(card => (
        <>
          {/*<div key={card.id} className={css.card}>
            <div className={css.cardImgBox}>
              <img src={card.img} className={css.image} alt={card.title} />
            </div>
            <div className={css.overlay}>
              <h3>{card.title}</h3>
            </div>
          </div>*/}
          <div className={css.card}>
            <div className={css.imageWrapper}>
              <img src={card.img} className={css.image} alt={card.title} />
              <div className={css.overlay} />
            </div>

            <div className={css.textSection}>
              <div className={css.category}>{card.series}</div>

              <div className={css.title}>
                {card.title}
              </div>
            </div>

            {/*<div className={css.descriptionSection}>
              <p className={css.description}>
               {card.series}
              </p>
            </div>*/}

            <div className={css.footer}>
              <div className={css.priceRow}>
                <span className={css.price}>{card.price}</span>

                <a
                  href={card.btnUrl}
                  target="_blank"
                  className={css.buyButton}
                >
                  Buy on Amazon
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className={css.icon}
                  >
                    <path d="M15 3h6v6" />
                    <path d="M10 14 21 3" />
                    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                  </svg>
                </a>
              </div>

              {/*<button className={css.quickButton} type="button">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className={css.icon}
                >
                  <path d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0" />
                  <circle cx={12} cy={12} r={3} />
                </svg>
                Quick Look
              </button>*/}
            </div>
          </div>
        </>
      ))}
    </div>
  );
};

export default CardGrid;
